import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ColorState {
  primary: string;
  secondary: string;
  textColor: string;
}

const initialState: ColorState = {
  primary: "",
  secondary: "",
  textColor: "",
};

const colorSlice = createSlice({
  name: "color",
  initialState,
  reducers: {
    setPrimary: (state, action: PayloadAction<string>) => {
      state.primary = action.payload;
    },
    setSecondary: (state, action: PayloadAction<string>) => {
      state.secondary = action.payload;
    },
    setTextColor: (state, action: PayloadAction<string>) => {
      state.textColor = action.payload;
    },
  },
});

export const { setPrimary, setSecondary, setTextColor } = colorSlice.actions;
export default colorSlice.reducer;
